import { render, staticRenderFns } from "./List.vue?vue&type=template&id=0b7b120a&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7b120a')) {
      api.createRecord('0b7b120a', component.options)
    } else {
      api.reload('0b7b120a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=0b7b120a&", function () {
      api.rerender('0b7b120a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/List.vue"
export default component.exports